import { ThemeOptions } from '@material-ui/core/styles/createTheme';

export const greenTable: ThemeOptions = {
  palette: {
    primary: {
      main: '#5f6441',
    },
    secondary: {
      main: '#000000',
    },
    /**
     * @todo add tertiary do cliente
     */
    tertiary: {
      main: '#E2E543',
    },
    additionalColors: {
      promoHighligts: '#5f6441',
    },
  },
};
